import { Receipt } from "lucide-react";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";

export const EmptyInsights = () => {
  return (
    <div className="space-y-6 p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center space-y-4 mb-8"
      >
        <Receipt className="h-16 w-16 mx-auto text-primary animate-bounce" />
        <h2 className="text-2xl font-bold text-gray-800">No Expenses Added Yet</h2>
        <p className="text-gray-600 max-w-md mx-auto">
          Start tracking your expenses to unlock detailed insights and analytics about your spending patterns.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { 
            icon: "PieChart", 
            color: "text-purple-500",
            title: "Category Analysis", 
            message: "Track spending patterns across different categories like food, transport, and accommodation." 
          },
          { 
            icon: "BarChart", 
            color: "text-blue-500",
            title: "Payment Distribution", 
            message: "Understand how expenses are distributed among trip participants." 
          },
          { 
            icon: "LineChart", 
            color: "text-green-500",
            title: "Daily Trends", 
            message: "Visualize your daily spending patterns and identify peak expense periods." 
          }
        ].map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="h-full"
          >
            <Card className="p-6 h-full bg-gradient-to-br from-white to-gray-50 hover:shadow-lg transition-all duration-300">
              <div className={`h-12 w-12 ${item.color} mb-4 animate-pulse`} />
              <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.message}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};